

import YoutubePlayer from './youtube-player';


const loadScript = function() {
    console.log('YoutubeControl loadScript()');

    let promise;

    if (global.YT) {
        console.log('YoutubeControl loadScript() Promise.resolve');

        promise = Promise.resolve(global.YT);
    } else {
        promise = new Promise((resolve, reject) => {
            console.log('YoutubeControl loadScript() new Promise');
    
            let script = document.createElement('script');
            script.onload = function() {
                console.log('YoutubeControl loadScript() script.onload [global.YT]', global.YT);
                
                resolve(global.YT);
            };
    
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
        });
    }

    return promise;
}



/**
 * YoutubeControl
 */
class YoutubeControl {
    constructor(config) {
        console.log('YoutubeControl.constructor() [config]', config);

        this.config = config;
        this.YT = undefined;
        this.players = [];
    }

    init(selector) {
        console.log('YoutubeControl.init() [selector]', selector);
    
        let elements = [...document.querySelectorAll(selector)];
        
        console.log('YoutubeControl.init() [elements]', elements);

        if (elements.length) {
            this.YT = loadScript();
        }

        return new Promise((resolve, reject) => {
            console.log('YoutubeControl.init() new Promise');

            if (!this.YT) {
                // reject();
                resolve([]);
            }

            this.YT.then((YT) => {
                for (let i = elements.length - 1; i >= 0; i--) {
                    console.log('YoutubeControl.init() [this, elements[i]]', this, elements[i]);
                    this.players[i] = new YoutubePlayer(this, elements[i]);
                }

                console.log('YoutubeControl.init() YT.then [this]', this);

                resolve(this.players);
            });
        });
    }

	stopPlayersExceptThis(exeptionPlayer) {
        console.log('YoutubeControl.stopPlayersExceptThis() [exeptionPlayer]', exeptionPlayer);
        
		// for (var playerId in players) {
		// 	if (playerId !== exeptionPlayerId) {
		// 		players[playerId].pauseVideo();
		// 	}
        // }
        
        for (let i = this.players.length - 1; i >= 0; i--) {
            if (this.players[i] !== exeptionPlayer) {
                this.players[i].pause();
            }
        }
    }
}
/**/



export default YoutubeControl;

